module.exports = __webpack_public_path__ + "static/media/thumbnail.2350d5c5.jpg";